import { Button, Link } from 'omakase';
import { FC } from 'react';
import { IconEdit } from '@tock/icons';
import { ReceiptButtonProps } from 'components/business/receipts/ReceiptActionButtons';

const ReceiptModifyButton: FC<ReceiptButtonProps> = ({ variant = 'button', ...rest }) => {
  return variant === 'button' ? (
    <Button
      variant="basic"
      size="medium"
      iconStart={<IconEdit />}
      data-testid="modify-booking"
      fullWidth
      {...rest}
    >
      Modify
    </Button>
  ) : (
    <Link data-testid="modify-booking" {...rest}>
      Modify reservation
    </Link>
  );
};

export default ReceiptModifyButton;
